import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const Siglas = () => {
  const siglasFPhoto = useWorkflowContainerFullStore(
    (state) => state.siglasFPhoto
  );

  const setSiglasFPhoto = useWorkflowContainerFullStore(
    (state) => state.setSiglasFPhoto
  );

  const {
    open: openSiglas,
    handleClose: handleCloseSiglas,
    handleOpen: handleOpenSiglas,
  } = useOpen();

  const fotoUrl = useBlobUrl(siglasFPhoto);


  return (
    <Grid
    item
    xs={12}
    sx={{
      mb: 2,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pl: 1.6,
    }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseSiglas}
        handleOpen={handleOpenSiglas}
        label="CONTENEDOR"
        open={openSiglas}
        setFoto={setSiglasFPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};
